import { Component } from '@angular/core';

import { SyncButtonComponent } from './sync-button.component';

/**
 * A thin status bar that appears at the top of the screen when syncing is in progress.
 * Extends SyncButtonComponent to reuse the same sync status logic.
 *
 * Usage:
 * ```html
 * <abs-sync-status-bar></abs-sync-status-bar>
 * ```
 *
 * The bar is only visible when syncStatus is 'InProgress'.
 */
@Component({
    standalone: false,
    selector: 'abs-sync-status-bar',
    template: ` <div class="sync-bar" *ngIf="syncStatus === 'InProgress'">
        <div class="sync-bar__progress"></div>
    </div>`,
    styles: [
        `
            :host {
                color: black;
            }
            .sync-bar {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                height: 3px;
                background: rgba(var(--ion-color-primary-rgb, 56, 128, 255), 0.2);
                z-index: 99999;
                overflow: hidden;
            }

            .sync-bar__progress {
                height: 100%;
                width: 30%;
                background: var(--ion-color-primary, #3880ff);
                animation: slide 1.5s ease-in-out infinite;
            }

            @keyframes slide {
                0% {
                    transform: translateX(-100%);
                }
                50% {
                    transform: translateX(233%);
                }
                100% {
                    transform: translateX(-100%);
                }
            }
        `
    ]
})
export class SyncStatusBarComponent extends SyncButtonComponent {
    mode = 'all' as any;
}
